"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.$inlineWithPointerRanges = exports.$anyWherePointerFragment = exports.$secondaryOnlyPointerFragment = exports.$firstOnlyPointerFragment = exports.$singleOnlyPointerFragment = exports.$pointer = exports.$pointerRange = exports.$pointerRanges = exports.pointerRangesCandidateChars = exports.reSuppressPointerRanges = void 0;
const helpers_1 = require("../../../law/std/helpers");
const num_1 = require("../../../law/num");
const controls_1 = require("../../../node/el/controls");
const factory_1 = require("../../../parser/cst/factory");
const lexical_1 = require("../../../parser/cst/rules/lexical");
const makeRangesRule_1 = __importDefault(require("../../../parser/cst/rules/makeRangesRule"));
const _sentenceChildren_1 = require("../../../parser/cst/rules/$sentenceChildren");
const lawNum_1 = require("../../../law/lawNum");
const generic_parser_1 = require("generic-parser");
const makeRange = (from, midText, to, trailingText, modifierParentheses, range) => {
    return {
        value: new controls_1.____PointerRange({
            from: from.value,
            midChildren: midText ? [new controls_1.__Text(midText.text, midText.range)] : [],
            to: to?.value ?? null,
            trailingChildren: [
                ...(trailingText ? [new controls_1.__Text(trailingText.text, trailingText.range)] : []),
                ...(modifierParentheses ? [modifierParentheses] : []),
            ],
            range,
        }),
        errors: [
            ...from.errors,
            ...(to?.errors ?? []),
        ],
    };
};
const makeRanges = (first, midText, rest, range) => {
    const children = [];
    const errors = [];
    children.push(first.value.value);
    errors.push(...first.value.errors);
    errors.push(...first.errors);
    if (midText)
        children.push(new controls_1.__Text(midText.text, midText.range));
    if (rest) {
        children.push(...rest.value.children);
        errors.push(...rest.errors);
    }
    return {
        value: new controls_1.____PointerRanges({
            children,
            range,
        }),
        errors,
    };
};
exports.reSuppressPointerRanges = /^[ァ-ヿ]{2,}/;
exports.pointerRangesCandidateChars = `${num_1.irohaChars}明大昭平令第前次こ本同付附iIｉＩvVｖＶxXｘＸ日`;
_a = (0, makeRangesRule_1.default)((() => exports.$pointer), makeRange, makeRanges), exports.$pointerRanges = _a.$ranges, exports.$pointerRange = _a.$range;
exports.$pointer = factory_1.factory
    .withName("pointer")
    .choice(c => c
    .orSequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => exports.$anyWherePointerFragment)
    .or(() => exports.$firstOnlyPointerFragment)), "first")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .zeroOrOne(() => _sentenceChildren_1.$ROUND_PARENTHESES_INLINE), "prevModifierParentheses")
    .and(r => r
    .choice(c => c
    .or(() => exports.$anyWherePointerFragment)
    .or(() => exports.$secondaryOnlyPointerFragment)), "fragment")
    .action(({ prevModifierParentheses, fragment }) => {
    return [
        ...(prevModifierParentheses ? [prevModifierParentheses] : []),
        { value: fragment, errors: [] },
    ];
}))), "rest")
    .action(({ first, rest, range }) => {
    return {
        value: new controls_1.____Pointer({
            children: [
                first,
                ...rest.map(s => s.map(({ value }) => value)).flat(),
            ],
            range: range(),
        }),
        errors: [...rest.map(s => s.map(({ errors }) => errors)).flat(2)],
    };
}))
    .orSequence(s => s
    .and(() => exports.$singleOnlyPointerFragment, "single")
    .action(({ single, range }) => {
    return {
        value: new controls_1.____Pointer({
            children: [single],
            range: range(),
        }),
        errors: [],
    };
})));
exports.$singleOnlyPointerFragment = factory_1.factory
    .withName("firstOnlyPointerFragment")
    .choice(c => c
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("前"))
    .and(r => r
    .choice(c => c
    .or(r => r.seqEqual("各"))
    .or(() => lexical_1.$kanjiDigits)), "count")
    .and(r => r.regExp(/^[編章節款目章条項号表]/), "type_char")), (({ text, count, type_char, range }) => {
    const targetType = (type_char === "表")
        ? "TableStruct"
        : (helpers_1.typeCharsMap)[type_char];
    if (count === "各") {
        return new controls_1.____PF({
            relPos: controls_1.RelPos.PREV,
            targetType,
            count: "all",
            name: text(),
            range: range(),
        });
    }
    else {
        const digits = count ? (0, num_1.parseKanjiNum)(count) : null;
        return new controls_1.____PF({
            relPos: controls_1.RelPos.PREV,
            targetType,
            count: digits ? `${digits}` : null,
            name: text(),
            range: range(),
        });
    }
}))));
class AppdxPointerRule extends generic_parser_1.Rule {
    classSignature = "AppdxPointerRule";
    constructor(name = null) {
        super(name);
    }
    __match__(offset, target, env) {
        const appdxPointers = env.options.appdxPointers;
        if (Array.isArray(appdxPointers)) {
            loop: for (const appdxPointer of appdxPointers) {
                if (offset + appdxPointer.pointerText.length <= target.length) {
                    for (let i = 0; i < appdxPointer.pointerText.length; i++) {
                        if (target[offset + i] !== appdxPointer.pointerText[i]) {
                            continue loop;
                        }
                    }
                    return {
                        ok: true,
                        nextOffset: offset + appdxPointer.pointerText.length,
                        value: appdxPointer,
                        env,
                    };
                }
            }
        }
        return {
            ok: false,
            offset,
            expected: this,
            prevFail: null,
        };
    }
    toString() { return this.name ?? "[AppdxPointerRule]"; }
}
exports.$firstOnlyPointerFragment = factory_1.factory
    .withName("firstOnlyPointerFragment")
    .choice(c => c
    .orSequence(s => s
    .and(new AppdxPointerRule())
    .action(({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "APPDX",
        name: text(),
        range: range(),
    });
}))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("次"))
    .and(r => r.regExp(/^[編章節款目章条項号表]/), "type_char")), (({ text, type_char, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NEXT,
        targetType: (type_char === "表")
            ? "TableStruct"
            : helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("前"))
    .and(r => r.regExp(/^[編章節款目章条項号表]/), "type_char")), (({ text, type_char, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.PREV,
        targetType: (type_char === "表")
            ? "TableStruct"
            : helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r
    .choice(c => c
    .or(r => r.seqEqual("この"))
    .or(r => r.seqEqual("本"))))
    .and(r => r.regExp(/^[編章節款目章条項号表]/), "type_char")), (({ text, type_char, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.HERE,
        targetType: (type_char === "表")
            ? "TableStruct"
            : helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r
    .choice(c => c
    .or(r => r.seqEqual("この"))))
    .and(r => r.regExp(/^(?:法律|勅令|政令|規則|省令|府令|内閣官房令|命令|附則|別表)/), "type")), (({ text, type, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.HERE,
        targetType: ((type === "附則")
            ? "SupplProvision"
            : (type === "別表")
                ? "APPDX"
                : "Law"),
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("同"))
    .and(r => r.regExp(/^[法編章節款目章条項号表]/), "type_char")), (({ text, type_char, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.SAME,
        targetType: (type_char === "表")
            ? "TableStruct"
            : helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.regExp(/^[付附]/))
    .and(r => r.seqEqual("則"), "type_char")), (({ text, type_char, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
}))));
exports.$secondaryOnlyPointerFragment = factory_1.factory
    .withName("secondaryOnlyPointerFragment")
    .choice(c => c
    .or(r => r
    .action(r => r
    .seqEqual("前段"), (({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "FIRSTPART",
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .seqEqual("後段"), (({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "LATTERPART",
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .seqEqual("ただし書"), (({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "PROVISO",
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .seqEqual("に基づく命令"), (({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "INFERIOR",
        name: text(),
        range: range(),
    });
})))
    .or(r => r
    .action(r => r
    .seqEqual("各号"), (({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.EACH,
        targetType: "Item",
        name: text(),
        range: range(),
    });
}))));
exports.$anyWherePointerFragment = factory_1.factory
    .withName("anyWherePointerFragment")
    .choice(c => c
    .orSequence(c => c
    .and(r => r
    .regExpObj(new RegExp(`^第[${lexical_1.kanjiDigits}]+([編章節款目章条項号表])(?:[のノ][${lexical_1.kanjiDigits}]+)*`)) // e.g. "第十二条", "第一章の二", "第一号の二の三"
, "match")
    .action(({ text, match, range }) => {
    const type_char = match[1];
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
}))
    .orSequence(c => c
    .and(r => r
    .regExpObj(new RegExp(`^第[${lexical_1.arabicDigits}]+([編章節款目章条項号表])(?:[のノ][${lexical_1.arabicDigits}]+)*`)) // e.g. "第１２条", "第1章の2", "第１号の２の３"
, "match")
    .action(({ text, match, range }) => {
    const type_char = match[1];
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: helpers_1.typeCharsMap[type_char],
        name: text(),
        range: range(),
    });
}))
    .orSequence(s => s
    .and(r => r.regExp(new RegExp(`^(?:[${num_1.irohaChars}](?![${num_1.irohaChars}])|[${lexical_1.romanDigits}]+)`))) // e.g. "イ", "Ｖ", "IV"
    .action(({ text, range }) => {
    return new controls_1.____PF({
        relPos: controls_1.RelPos.NAMED,
        targetType: "SUBITEM",
        name: text(),
        range: range(),
    });
})));
const reLawNumLike = new RegExp(`^${lawNum_1.ptnLawNumLike}`);
exports.$inlineWithPointerRanges = factory_1.factory
    .withName("inlineWithPointerRanges")
    .choice(c => c
    .orSequence(s => s
    .and(r => r.regExp(exports.reSuppressPointerRanges), "text")
    .action(({ text, range }) => ({
    value: new controls_1.__Text(text, range()),
    errors: [],
})))
    .orSequence(s => s
    .and(r => r.regExp(reLawNumLike), "text")
    .action(({ text, range }) => ({
    value: new controls_1.____LawNum(text, range()),
    errors: [],
})))
    .or(() => exports.$pointerRanges));
exports.default = exports.$pointerRanges;
//# sourceMappingURL=$pointerRanges.js.map